"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProductPages = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var query_string_1 = __importDefault(require("query-string"));
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_notification_1 = require("hooks/use-notification");
var use_dialog_1 = require("hooks/use-dialog");
var use_stores_1 = require("hooks/use-stores");
var Breadcrumb_1 = __importDefault(require("components/common/navigation/Breadcrumb"));
var EditProductGallery_1 = __importDefault(require("./EditProductGallery"));
var EditProductAttachments_1 = __importDefault(require("./EditProductAttachments"));
var EditProductBasicInfo_1 = __importDefault(require("./EditProductBasicInfo"));
var Dialog_1 = require("../../Dialog");
var EditProductSpecs_1 = __importDefault(require("./edit-product-specs/EditProductSpecs"));
var EditProductOptions_1 = __importDefault(require("./edit-product-options/EditProductOptions"));
var Notification_1 = require("../../Notification");
var utils_1 = require("../../../util/utils");
var basic_info_icon_svg_1 = __importDefault(require("res/img/basic-info-icon.svg"));
var basic_info_icon_yellow_svg_1 = __importDefault(require("res/img/basic-info-icon-yellow.svg"));
var image_icon_svg_1 = __importDefault(require("res/img/image-icon.svg"));
var image_icon_yellow_svg_1 = __importDefault(require("res/img/image-icon-yellow.svg"));
var attachment_icon_svg_1 = __importDefault(require("res/img/attachment-icon.svg"));
var attachment_icon_yellow_svg_1 = __importDefault(require("res/img/attachment-icon-yellow.svg"));
var filter_icon_svg_1 = __importDefault(require("res/img/filter-icon.svg"));
var filter_icon_yellow_svg_1 = __importDefault(require("res/img/filter-icon-yellow.svg"));
var inventory_icon_svg_1 = __importDefault(require("res/img/inventory-icon.svg"));
var inventory_icon_yellow_svg_1 = __importDefault(require("res/img/inventory-icon-yellow.svg"));
var related_icon_svg_1 = __importDefault(require("res/img/related-icon.svg"));
var related_icon_yellow_svg_1 = __importDefault(require("res/img/related-icon-yellow.svg"));
var reviews_icon_svg_1 = __importDefault(require("res/img/reviews-icon.svg"));
var reviews_icon_yellow_svg_1 = __importDefault(require("res/img/reviews-icon-yellow.svg"));
var EditProductReviews_1 = __importDefault(require("./edit-product-reviews/EditProductReviews"));
var EditRelatedProducts_1 = __importDefault(require("./edit-related-products/EditRelatedProducts"));
var TableHeading_1 = require("../../common/table/TableHeading");
var EditProductPages;
(function (EditProductPages) {
    EditProductPages[EditProductPages["BASIC_INFORMATION"] = 0] = "BASIC_INFORMATION";
    EditProductPages[EditProductPages["PRODUCT_IMAGES"] = 1] = "PRODUCT_IMAGES";
    EditProductPages[EditProductPages["PRODUCT_ATTACHMENTS"] = 2] = "PRODUCT_ATTACHMENTS";
    EditProductPages[EditProductPages["PRODUCT_SPECIFICATIONS"] = 3] = "PRODUCT_SPECIFICATIONS";
    EditProductPages[EditProductPages["PRODUCT_OPTIONS"] = 4] = "PRODUCT_OPTIONS";
    EditProductPages[EditProductPages["RELATED_PRODUCTS"] = 5] = "RELATED_PRODUCTS";
    EditProductPages[EditProductPages["PRODUCT_REVIEWS"] = 6] = "PRODUCT_REVIEWS";
})(EditProductPages = exports.EditProductPages || (exports.EditProductPages = {}));
var getIcon = function (page, active) {
    if (active === void 0) { active = false; }
    switch (page) {
        case EditProductPages.BASIC_INFORMATION:
            return active ? basic_info_icon_yellow_svg_1.default : basic_info_icon_svg_1.default;
        case EditProductPages.PRODUCT_IMAGES:
            return active ? image_icon_yellow_svg_1.default : image_icon_svg_1.default;
        case EditProductPages.PRODUCT_ATTACHMENTS:
            return active ? attachment_icon_yellow_svg_1.default : attachment_icon_svg_1.default;
        case EditProductPages.PRODUCT_SPECIFICATIONS:
            return active ? filter_icon_yellow_svg_1.default : filter_icon_svg_1.default;
        case EditProductPages.PRODUCT_OPTIONS:
            return active ? inventory_icon_yellow_svg_1.default : inventory_icon_svg_1.default;
        case EditProductPages.RELATED_PRODUCTS:
            return active ? related_icon_yellow_svg_1.default : related_icon_svg_1.default;
        case EditProductPages.PRODUCT_REVIEWS:
            return active ? reviews_icon_yellow_svg_1.default : reviews_icon_svg_1.default;
        default:
            return null;
    }
};
var SAVE_MESSAGE = 'Product has been saved';
var EditProduct = mobx_react_1.observer(function () {
    var _a = use_stores_1.useStores(), productsStore = _a.productsStore, productCategoriesStore = _a.productCategoriesStore, productSubCategoriesStore = _a.productSubCategoriesStore, apiStore = _a.apiStore, userStore = _a.userStore, prefsStore = _a.prefsStore, productPageStore = _a.productPageStore;
    var _b = react_1.useState([]), subCategories = _b[0], setSubCategories = _b[1];
    var params = react_router_dom_1.useParams();
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var location = react_router_dom_1.useLocation();
    var busyRoutes = apiStore.data.busyRoutes;
    var apiRoutes = config_1.default.apiRoutes;
    var getInitialPage = function () {
        var query = query_string_1.default.parse(location.search);
        if (query && query.duplicate === 'true') {
            return EditProductPages.PRODUCT_IMAGES;
        }
        return EditProductPages.BASIC_INFORMATION;
    };
    var _c = react_1.useState(getInitialPage()), page = _c[0], setPage = _c[1];
    var getActive = function () {
        if ((!productsStore.data || productsStore.data.length <= 0) &&
            !busyRoutes.includes(apiRoutes.PRODUCTS + ("?page=" + prefsStore.data.productsTable.page + "&limit=" + prefsStore.data.productsTable.perPage + "&sort=" + ((prefsStore.data.productsTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.productsTable.sort.name !== null ? prefsStore.data.productsTable.sort.name : 'id')) + "&search=" + prefsStore.data.productsTable.search))) {
            api_1.default.getProducts(prefsStore.data.productsTable.page, prefsStore.data.productsTable.perPage, (prefsStore.data.productsTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.productsTable.sort.name !== null ? prefsStore.data.productsTable.sort.name : 'id'), prefsStore.data.productsTable.search)
                .then(function (response) {
                productsStore.setData(response.data.products);
                productPageStore.setData(response.data.page);
            })
                .catch(api_1.catchHandler);
        }
        else {
            return searchProducts();
        }
        function searchProducts() {
            for (var _i = 0, _a = productsStore.data; _i < _a.length; _i++) {
                var product_1 = _a[_i];
                if (product_1.id === parseInt(params.id)) {
                    console.log(product_1);
                    return product_1;
                }
            }
            return { productCategory: null };
        }
        return { productCategory: null };
    };
    var _d = react_1.useState(getActive()), product = _d[0], setProduct = _d[1];
    var _e = react_1.useState(product && product.description || null), prevDescription = _e[0], setPrevDescription = _e[1];
    var keyTimerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (productCategoriesStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.PRODUCT_CATEGORIES)) {
            api_1.default.getProductCategories()
                .then(function (response) { return productCategoriesStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
        if (productSubCategoriesStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.PRODUCT_SUB_CATEGORIES)) {
            api_1.default.getProductSubCategories()
                .then(function (response) { return productSubCategoriesStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
        return function () {
            clearTimeout(keyTimerRef.current);
        };
    }, []);
    react_1.useEffect(function () {
        var newData = getActive();
        document.title = "Shop CMS - " + (newData && newData.name || '');
        setProduct(newData);
        getSubCategories();
    }, [params.id, productsStore.data]);
    var keyUpHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        var numberEx = /^[+-]?\d+(\.\d+)?$/;
        if (value === '0')
            value = 0;
        else if (numberEx.test(value)) {
            value = Math.round(value * 100) / 100;
        }
        clearTimeout(keyTimerRef.current);
        keyTimerRef.current = setTimeout(function () {
            var _a;
            saveProduct((_a = {},
                _a[name] = value,
                _a));
        }, 500);
    };
    var booleanToggleHandler = function (name) {
        var _a;
        api_1.default.editProduct((_a = {
                id: product.id
            },
            _a[name] = !product[name],
            _a))
            .then(function (response) { return productsStore.editDataItem(response.data); })
            .catch(api_1.catchHandler);
    };
    var categoryChangeHandler = function (productCategory) {
        saveProduct({
            productCategoryId: productCategory.id
        });
    };
    var categorySubmitHandler = function (value) {
        var newItem = {
            name: value
        };
        api_1.default.createProductCategory(newItem)
            .then(function (response) {
            productCategoriesStore.addDataItem(response.data);
            saveProduct({
                productCategoryId: response.data.id
            });
        })
            .catch(api_1.catchHandler);
    };
    react_1.useEffect(function () {
        if (product.productCategory) {
            getSubCategories();
        }
    }, [product.productCategory, productSubCategoriesStore.data]);
    var getSubCategories = function () {
        var newSubCategories = [];
        if (utils_1.isBusy(apiRoutes.PRODUCT_SUB_CATEGORIES))
            return;
        for (var _i = 0, _a = productSubCategoriesStore.data; _i < _a.length; _i++) {
            var subCategory = _a[_i];
            if (!subCategory || !subCategory.productCategory)
                continue;
            if (!product || !product.productCategory)
                continue;
            if (subCategory.productCategory.id === product.productCategory.id) {
                newSubCategories.push(subCategory);
            }
        }
        setSubCategories(newSubCategories);
    };
    var subCategoryChangeHandler = function (productSubCategory) {
        saveProduct({
            productSubCategoryId: productSubCategory.id
        });
    };
    var subCategorySubmitHandler = function (value) {
        var newItem = {
            name: value,
            productCategoryId: product.productCategory.id
        };
        api_1.default.createProductSubCategory(newItem)
            .then(function (response) {
            productSubCategoriesStore.addDataItem(response.data);
            saveProduct({
                productSubCategoryId: response.data.id
            });
        })
            .catch(api_1.catchHandler);
    };
    var saveProduct = function (newData) {
        api_1.default.editProduct(__assign({ id: product.id }, newData))
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: SAVE_MESSAGE
            });
        })
            .catch(api_1.catchHandler);
    };
    var changeDescriptionHandler = function (html) {
        if (prevDescription === html)
            return;
        setPrevDescription(html);
        saveProduct({
            description: html
        });
    };
    var deleteImageHandler = function (image) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: 'Delete Image',
            description: 'Are you sure you want to delete this image?'
        })
            .then(function () {
            api_1.default.deleteImage(image)
                .then(function () {
                productsStore.editDataItem(__assign(__assign({}, product), { images: utils_1.reOrderImageAfterDelete(image, product.images) }));
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Image has been deleted'
                });
            })
                .catch(api_1.catchHandler);
        });
    };
    var changeImageOrderHandler = function (images) {
        productsStore.editDataItem(__assign(__assign({}, product), { images: images }));
        api_1.default.reOrderProductImages(product.id, images)
            .then(function (response) {
            productsStore.editDataItem(response.data);
        })
            .catch(api_1.catchHandler);
    };
    var getImageWidth = function (url) { return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () { return resolve(img.width); };
        img.src = url;
    }); };
    var uploadImageHandler = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        function uploadImages() {
            api_1.default.putProductImages(product.id, formData)
                .then(function (response) {
                productsStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Image/s have been uploaded'
                });
            })
                .catch(api_1.catchHandler);
        }
        var files, formData, warnings, i, file, url, imgWidth;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    files = e.currentTarget.files;
                    formData = new FormData();
                    warnings = [];
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < files.length)) return [3 /*break*/, 4];
                    file = files[i];
                    url = URL.createObjectURL(file);
                    return [4 /*yield*/, getImageWidth(url)];
                case 2:
                    imgWidth = _a.sent();
                    if (imgWidth < 1000)
                        warnings.push(file.name);
                    formData.append('images[]', file);
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    formData.append('_method', 'PUT');
                    if (warnings.length > 0) {
                        dialog({
                            variant: Dialog_1.DialogVariants.CONFIRMATION,
                            title: 'Image(s) not optimal',
                            description: "The following image(s): " + warnings.join(",") + " are below 1000px wide. These images will not display well on larger screens or retina displays. Would you like to continue with this upload?",
                            catchOnCancel: true
                        }).then(function () {
                            uploadImages();
                        });
                        return [2 /*return*/];
                    }
                    uploadImages();
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteAttachmentHandler = function (attachment) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: 'Delete Attachment',
            description: 'Are you sure you want to delete this attachment?'
        })
            .then(function () {
            api_1.default.deleteAttachment(attachment)
                .then(function () {
                productsStore.editDataItem(__assign(__assign({}, product), { attachments: utils_1.reOrderAttachmentAfterDelete(attachment, product.attachments) }));
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Attachment has been deleted'
                });
            })
                .catch(api_1.catchHandler);
        });
    };
    var changeAttachmentOrderHandler = function (attachments) {
        productsStore.editDataItem(__assign(__assign({}, product), { attachments: attachments }));
        api_1.default.reOrderProductAttachments(product.id, attachments)
            .then(function (response) {
            productsStore.editDataItem(response.data);
        })
            .catch(api_1.catchHandler);
    };
    var uploadAttachmentHandler = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        function uploadAttachments() {
            api_1.default.putProductAttachments(product.id, formData)
                .then(function (response) {
                productsStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Attachment/s have been uploaded'
                });
            })
                .catch(api_1.catchHandler);
        }
        var files, formData, i, file;
        return __generator(this, function (_a) {
            files = e.currentTarget.files;
            formData = new FormData();
            for (i = 0; i < files.length; i++) {
                file = files[i];
                formData.append('attachments[]', file);
            }
            formData.append('_method', 'PUT');
            uploadAttachments();
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement("div", { className: 'edit-product page' },
        product &&
            react_1.default.createElement(Breadcrumb_1.default, { items: [
                    { text: 'Products', href: '/products' },
                    { text: product.name, href: "/products/edit/" + product.id }
                ] }),
        react_1.default.createElement("div", { className: 'edit-product__main flex flex-row' },
            react_1.default.createElement("div", { className: 'edit-product__menu' }, Object.keys(EditProductPages)
                .filter(function (key) { return !/\d+/.test(key); })
                .map(function (key) {
                var pageName = key.replace(/_/g, ' ').toLowerCase();
                var active = page === EditProductPages[key];
                return (react_1.default.createElement("button", { className: 'edit-product__menu__item flex flex-row', title: pageName, key: key, onClick: function () { return setPage(EditProductPages[key]); }, "aria-selected": active },
                    react_1.default.createElement("img", { src: getIcon(EditProductPages[key], active), alt: pageName }),
                    react_1.default.createElement("span", null, pageName)));
            })),
            react_1.default.createElement("div", { className: 'edit-product__content thin-scroll' },
                page === EditProductPages.BASIC_INFORMATION &&
                    product.hasOwnProperty('id') &&
                    react_1.default.createElement(EditProductBasicInfo_1.default, { data: product, user: userStore.data, productCategories: productCategoriesStore.data, productSubCategories: subCategories, onKeyUp: keyUpHandler, onToggleBoolean: booleanToggleHandler, onChangeDescription: changeDescriptionHandler, onChangeCategory: categoryChangeHandler, onSubmitCategory: categorySubmitHandler, onChangeSubCategory: subCategoryChangeHandler, onSubmitSubCategory: subCategorySubmitHandler, busy: busyRoutes.includes(apiRoutes.PRODUCTS + ("?page=" + prefsStore.data.productsTable.page + "&limit=" + prefsStore.data.productsTable.perPage + "&sort=" + ((prefsStore.data.productsTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.productsTable.sort.name !== null ? prefsStore.data.productsTable.sort.name : 'id')) + "&search=" + prefsStore.data.productsTable.search)), categoriesBusy: busyRoutes.includes(apiRoutes.PRODUCT_CATEGORIES) }),
                page === EditProductPages.PRODUCT_IMAGES &&
                    product.hasOwnProperty('id') &&
                    react_1.default.createElement(EditProductGallery_1.default, { images: product.images, onDelete: deleteImageHandler, onChangeOrder: changeImageOrderHandler, onUpload: uploadImageHandler, busy: busyRoutes.includes(apiRoutes.PRODUCTS + apiRoutes.IMAGES) }),
                page === EditProductPages.PRODUCT_ATTACHMENTS &&
                    product.hasOwnProperty('id') &&
                    react_1.default.createElement(EditProductAttachments_1.default, { attachments: product.attachments, onDelete: deleteAttachmentHandler, onChangeOrder: changeAttachmentOrderHandler, onUpload: uploadAttachmentHandler, busy: busyRoutes.includes(apiRoutes.PRODUCTS + apiRoutes.ATTACHMENTS) }),
                page === EditProductPages.PRODUCT_SPECIFICATIONS &&
                    product.hasOwnProperty('id') &&
                    react_1.default.createElement(EditProductSpecs_1.default, { product: product }),
                page === EditProductPages.PRODUCT_OPTIONS &&
                    product.hasOwnProperty('id') &&
                    react_1.default.createElement(EditProductOptions_1.default, { product: product }),
                page === EditProductPages.RELATED_PRODUCTS &&
                    product.hasOwnProperty('id') &&
                    react_1.default.createElement(EditRelatedProducts_1.default, { product: product, products: productsStore.data }),
                page === EditProductPages.PRODUCT_REVIEWS &&
                    product.hasOwnProperty('id') &&
                    react_1.default.createElement(EditProductReviews_1.default, { product: product })))));
});
exports.default = EditProduct;
